// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1152E4", // Your primary color
    },
    secondary: {
      main: "#ff4081", // Your secondary color
    },
    background: {
      default: "white", // App background
      paper: "white", // Paper components (like cards)
    },
    text: {
      primary: "#333333", // Default text color
      secondary: "#757575", // Secondary text color
    },
    accent: {
      main: "#ffc107", // Custom accent color if needed
    },
  },
  typography: {
    fontFamily: "Helvetica Neue, Arial, sans-serif",
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    body1: {
      fontSize: "1rem",
    },
  },
  shape: {
    borderRadius: 12, // Custom border radius for components
  },
  colors: {
    white: "#FFFFFF",
    amber: "#EAB016",
    red: "#FF5C5C", // danger
    green: "#219A79", // success
    blue: "#1152E4", // primary
    darkBlue: "#1A0B27",
    mediumBlue: "#1A185D",
    lightGray: "#DBDBDB",
    darkGray: "#868A9C",
    headerPurple: "#20122C",
    darkPurple: "#20112D",
    mediumPurple: "#2A1E38",
    unselectedTab: "#39314A",
    lineColor: "#707070",
    paleBlue: "#4164D8",
    palePurple: "#3A324A",
  },
});

export default theme;
